// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Omni Environments API
 * API to manage Omni Development Environments
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FieldOperator } from './FieldOperator';
import {
  FieldOperatorFromJSON,
  FieldOperatorFromJSONTyped,
  FieldOperatorToJSON,
  FieldOperatorToJSONTyped,
} from './FieldOperator';

/**
 *
 * @export
 * @interface FieldMatchExpression
 */
export interface FieldMatchExpression {
  /**
   *
   * @type {string}
   * @memberof FieldMatchExpression
   */
  key?: string;
  /**
   *
   * @type {FieldOperator}
   * @memberof FieldMatchExpression
   */
  operator?: FieldOperator;
  /**
   *
   * @type {Array<string>}
   * @memberof FieldMatchExpression
   */
  values?: Array<string>;
}

/**
 * Check if a given object implements the FieldMatchExpression interface.
 */
export function instanceOfFieldMatchExpression(
  value: object,
): value is FieldMatchExpression {
  return true;
}

export function FieldMatchExpressionFromJSON(json: any): FieldMatchExpression {
  return FieldMatchExpressionFromJSONTyped(json, false);
}

export function FieldMatchExpressionFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): FieldMatchExpression {
  if (json == null) {
    return json;
  }
  return {
    key: json['key'] == null ? undefined : json['key'],
    operator:
      json['operator'] == null
        ? undefined
        : FieldOperatorFromJSON(json['operator']),
    values: json['values'] == null ? undefined : json['values'],
  };
}

export function FieldMatchExpressionToJSON(json: any): FieldMatchExpression {
  return FieldMatchExpressionToJSONTyped(json, false);
}

export function FieldMatchExpressionToJSONTyped(
  value?: FieldMatchExpression | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    key: value['key'],
    operator: FieldOperatorToJSON(value['operator']),
    values: value['values'],
  };
}
